const Vue = require('vue').default
const axios = require("axios").default



var PageTop = {
  data: function () {
    return {
      news3_index: -1,
      isShowModal: false,
      modalArticle: null,
      date: '',
      time: '',
      tmpHeatMapOption: ["1"],
      works_3: [],
      trafficInfo: [],

      //
      swiperOptionConst01: {
        initialSlide: 0,
        loop: false,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.page-swiper-const01-wrap .swiper-button-next',
          prevEl: '.page-swiper-const01-wrap .swiper-button-prev',
        },
        pagination: {
          el: '.page-swiper-const01-wrap .swiper-pagination',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        }
      },
      swiperOptionConst02: {
        initialSlide: 0,
        loop: false,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.page-swiper-const02-wrap .swiper-button-next',
          prevEl: '.page-swiper-const02-wrap .swiper-button-prev',
        },
        pagination: {
          el: '.page-swiper-const02-wrap .swiper-pagination',
          clickable: true
        },
      },
      swiperOptionConst03: {
        watchOverflow: true,
        initialSlide: 0,
        loop: false,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.nx-map__info.onlySp .swiper-button-next',
          prevEl: '.nx-map__info.onlySp .swiper-button-prev',
        },
        pagination: {
          el: '.nx-map__info.onlySp .swiper-pagination',
          clickable: true
        },
      },
      swiperOptionConst04: {
        initialSlide: 0,
        loop: false,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.page-swiper-const04-wrap .swiper-button-next',
          prevEl: '.page-swiper-const04-wrap .swiper-button-prev',
        },
        pagination: {
          el: '.page-swiper-const04-wrap .swiper-pagination',
          clickable: true
        },
      },
    }
  },
  watch: {
  },
  created() {
    axios.get('https://nexco.tag-labs.jp/w-nexco/map/timedata_hanwa_navi_2021.json?t=' + (new Date()).getTime())
      .then((res) => {
        this.trafficInfo = res.data
      })

    const result = this.informations.find((v) => {
      if (v.custom.checkbox && v.custom.checkbox.indexOf('modalOn') > -1) {
        var start = moment(v.custom.modal_date_start, "YYYY-MM-DD HH:mm:ss")
        var end = moment(v.custom.modal_date_end, "YYYY-MM-DD HH:mm:ss")
        var now = moment()
        if (start.isSameOrBefore(now) && now.isSameOrBefore(end)) {
          return true
        }
      }
    })
    if (result) {
      this.isShowModal = true
      this.modalArticle = result
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.news3_index = 0
      this.nextNews()
    }, 20)
    var timer = setInterval(this.trafficTime, 1000);

    // google map
    var domain = location.href.replace("https://", "").replace("http://", "").replace(/./g, "").replace(/\//g, "")
    domain = domain.replace(/\?.*$/, '')
    domain = domain.replace(/#.*$/, '')
    var year = (new Date()).getFullYear()
    var channel = domain + year
    var sc = document.createElement('script')
    sc.setAttribute('src', '//maps.google.com/maps/api/js?v=3.45&key=AIzaSyAoTjJCRVnZ0nIfAnHCZDxmFfGawQHQIf8&channel=' + channel + '&language=ja&libraries=geometry')
    document.head.appendChild(sc)
    this.initGoogleMap()

    var tsc = document.createElement('script')
    tsc.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    document.head.appendChild(tsc)

    axios.get('/2021_hanwa/cms/work_calendar.json?t=' + (new Date()).getTime()).then((res) => {
      this.works_3 = res.data.slice(0, 3)
      // this.works = res.data
      // console.log(this.works_3)
      // this.datasource = this.works
      // console.log(this.datasource)

      if (this.enablePager) this.pager = this.createPagerHTML()
    })

    var _urlHash = location.hash;
    if (_urlHash) {
      this.scrollToHash()
    }

    // Route Monitoring
    this.setRouteTime();
  },

  methods: {
    nextNews() {
      let li = this.$refs.ticker.querySelector(`li:nth-child(${this.news3_index + 1})`)
      const parentwidth = this.$refs.ticker.clientWidth
      const width = li.clientWidth
      li.style.transform = `translate3d(${parentwidth}px,0,0)`
      setTimeout(() => {
        // 行の実際の長さを取得        
        let li = this.$refs.ticker.querySelector(`li:nth-child(${this.news3_index + 1})`)
        const width = li.clientWidth
        li.style.transform = 'translate3d(0,0,0)'
        li.style.transition = 'opacity .3s ease-in,transform .5s cubic-bezier(.39,.575,.565,1),-webkit-transform .5s cubic-bezier(.39,.575,.565,1)'

        setTimeout(() => {
          // 流れるアニメーション
          li.style.transform = `translate3d(${-width - 50}px, 0, 0)`
          li.style.transitionDuration = `${width * 15}ms`

          setTimeout(() => {
            this.news3_index++
            if (this.news3_index >= this.news_3.length) {
              this.news3_index = 0
            }
            li.style.transform = ''
            li.style.transitionDuration = ''
            this.nextNews()
          }, width * 15 + 350)
        }, 1500)
      }, 1000)
    },
    initGoogleMap() {
      if (window.google) {
        initGoogleMap()
      } else {
        setTimeout(() => {
          this.initGoogleMap()
        }, 500)
      }
    },
    trafficTime: function () {
      var current_date = new Date()
      this.time = ('0' + current_date.getHours()).slice(-2) + ':' + ('0' + current_date.getMinutes()).slice(-2)
      // console.log(this.time)
      this.date = current_date.getFullYear() + '/' + (current_date.getMonth() + 1) + '/' + current_date.getDate()
    },
    scrollToHash() {
      const hash = location.hash;
      const _this = this;
      window: onload = function () {
        _this.$scrollTo(hash, 0, { offset: 0 })
      }
    },
    getTrafficInfo(rid) {
      var roadData = this.trafficInfo.find((d) => {
        return d.id == rid
      })
      let text = "-"

      if (roadData) {
        try {
          var time = roadData.time
          var base = roadData.base_time
          if (isNaN(time) || isNaN(base)) {
            throw new Error('Data is not a number.')
          }
          if (time > 0 && base > 0) {
            var x = time / base
            text = time + '<small>分</small>'
            if (x > 2) {
              return {
                text: text,
                cls: {
                  'traffic-jam': true,
                  'congestion-color': false,
                  'traffic-font': true
                }
              }
            } else if (x > 1.5) {
              return {
                text: text,
                cls: {
                  'traffic-jam': false,
                  'congestion-color': true,
                  'traffic-font': true
                }
              }
            } else {
              return {
                text: text,
                cls: {
                  'traffic-jam': false,
                  'congestion-color': false,
                  'traffic-font': true
                }
              }
            }
          } else {
            throw new Error('Invalid number.')
          }
        } catch (e) {
          text = '！'
        }
      }

      return {
        text: text,
        cls: 'traffic-font caution'
      }
    },
    setRouteTime() {
      ROUTETIME.setTimeCOMAPROBE(
        function () {
          //所要時間更新後の処理(通常時間と比較して色付けなど)
          elementList = document.querySelectorAll(".control_time_comaprobe");
          for (i = 0; i < elementList.length; i++) {
            if(elementList[i].innerText == -1){
              elementList[i].innerText = "!";
            } else {
              elementList[i].innerHTML = elementList[i].textContent + "<small>分</small>";
            }
          }
        },
        5*60*1000 //更新間隔(ミリ秒) //更新間隔(ミリ秒)
      );
    }
  }
}

module.exports = PageTop